import React from 'react';

import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-areas:
    'header'
    'content';

  @media (min-width: 768px) {
    grid-template-columns: 200px auto;
    grid-template-areas:
      'header  header'
      'sidebar content';
  }
`;

const Main = props => {
  return <Wrapper visible={true}>{props.children}</Wrapper>;
};

export default Main;
